import React, {
  useState,
  useMemo,
  useEffect,
  useCallback,
  useRef,
} from "react";
import { Row, Col } from "react-bootstrap";
import { withRouter } from "react-router-dom";
// Import icons
import { Funnel, ArrowLeft } from "react-bootstrap-icons";
import Select from "react-select";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import jwt_decode from "jwt-decode";
import Axios from "axios";
import config from "react-global-configuration";
import { BeatLoader } from "react-spinners";
import { css } from "@emotion/core";
import DetailedTransactionTable from "./DetailedTransactionTable";
import StoreDashboard from "./StoreDashboard";
import { List } from "react-virtualized";
import { user_activities } from "../../helpers/utils";

import "../../assets/css/mydashboard.css";

// Loading spinner CSS override
const override = css`
  display: block;
  margin: 0 auto;
  text-align: center;
`;

// Virtualized MenuList component for large dropdowns
const VirtualizedMenuList = (props) => {
  const children = props.children;

  if (!Array.isArray(children)) {
    return <div className="no-options-message">{children}</div>;
  }

  const no_of_rows = children.length;
  const drop_down_height = no_of_rows < 9 ? 35 * no_of_rows : 300;

  const rowRenderer = ({ key, index, style }) => (
    <div key={key} style={style}>
      {children[index]}
    </div>
  );

  return (
    <List
      style={{ width: "100%" }}
      width={300}
      height={drop_down_height}
      rowHeight={35}
      rowCount={no_of_rows}
      rowRenderer={rowRenderer}
    />
  );
};

const LinkTeamDashboard = (props) => {
  const { location, history } = props;
  const [showDetailTable, setShowDetailTable] = useState(false);
  const [showStoreDashboard, setShowStoreDashboard] = useState(false);
  const [selectedUtid, setSelectedUtid] = useState(null);
  const [selectedManagers, setSelectedManagers] = useState([]); // Multi-select for managers
  const [selectedUsers, setSelectedUsers] = useState([]); // Multi-select for team members
  const [selectedStore, setSelectedStore] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [asoEmpCode, setAsoEmpCode] = useState(null);
  const [managerList, setManagerList] = useState([]);
  const [storeList, setStoreList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState(null);
  const [loadingSummary, setLoadingSummary] = useState(false);
  const [months, setMonths] = useState([]); // Months from API response
  const [storeDashboardData, setStoreDashboardData] = useState(null);
  const [loadingStoreDashboard, setLoadingStoreDashboard] = useState(false);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [detailedData, setDetailedData] = useState([]);
  const [terminalType, setTerminalType] = useState("");
  // Segment Filter State Removed
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [isICUser, setIsICUser] = useState(false);

  const [showFilters, setShowFilters] = useState(false);
  const previousSelectionRef = useRef([]); // Track previous selection to detect newly clicked member
  const [tokenReady, setTokenReady] = useState(false);
  const isFilterChangeRef = useRef(false);
  const [cameFromSalesPerformance, setCameFromSalesPerformance] =
    useState(false);
  // Use a ref to track if we are currently handling a redirection to prevent race conditions
  const isRedirectionProcessingRef = useRef(
    location.state?.fromSalesPerformance || false,
  );
  // Capture redirection payload in a Ref so it persists across renders even after history.replace
  const redirectionPayloadRef = useRef(null);
  // Flag to prevent bootstrap after successful redirection
  const hasCompletedRedirectionRef = useRef(false);
  // Flag to prevent initialization effect from running multiple times
  const hasInitializedRef = useRef(false);
  // AbortController ref to cancel pending terminal API calls when navigating away
  const terminalsAbortControllerRef = useRef(null);

  // Helper to track user activity
  const trackUserActivity = useCallback((reportName) => {
    try {
      const token = localStorage.getItem("usertoken");
      if (token) {
        const decoded = jwt_decode(token);
        const userId = decoded._id;
        // Check if firstName and lastName exist, otherwise use a fallback or empty string
        const firstName = decoded.firstName || "";
        const lastName = decoded.lastName || "";
        const userName = (firstName + " " + lastName).trim() || "";
        const email = decoded.email || "";
        user_activities(0, userId, userName, email, reportName, "sparcs");
      }
    } catch (error) {
      console.error("Error tracking user activity:", error);
    }
  }, []);

  // Initialize redirection payload if coming from Sales Performance
  if (
    location.state &&
    location.state.fromSalesPerformance &&
    !redirectionPayloadRef.current
  ) {
    redirectionPayloadRef.current = {
      selectedICEmpCode: location.state.selectedICEmpCode,
      selectedICEmpCodes: location.state.selectedICEmpCodes,
      selectedStoreUTIDs: location.state.selectedStoreUTIDs,
      userEmpCode: location.state.userEmpCode, // Manager/user empCode as team_id
    };

    // Clean up location state immediately
    if (history && history.replace) {
      history.replace({
        ...location,
        state: {
          ...location.state,
          fromSalesPerformance: false,
          selectedStoreUTIDs: null,
          selectedICEmpCode: null,
          selectedICEmpCodes: null,
        },
      });
    }
  }

  // Handle Redirection logic - re-runs whenever userList is updated
  useEffect(() => {
    console.log(
      "[REDIRECTION EFFECT] Running. redirectionPayloadRef:",
      redirectionPayloadRef.current,
      "userList.length:",
      userList.length,
    );
    if (!redirectionPayloadRef.current) return;

    const payload = redirectionPayloadRef.current;
    let successfullyApplied = false;

    // Case 1: Both userEmpCode (for filters) and selectedICEmpCode (for genie API) are provided
    // This happens when clicking on an IC name from Sales Performance
    if (payload.userEmpCode && payload.selectedICEmpCode) {
      console.log(
        "[REDIRECTION EFFECT] Has both userEmpCode and selectedICEmpCode:",
        payload.userEmpCode,
        payload.selectedICEmpCode,
      );
      if (userList.length > 0) {
        const icUser = userList.find(
          (user) => String(user.value) === String(payload.selectedICEmpCode),
        );
        if (icUser) {
          // Select the specific IC in the dropdown
          setSelectedUsers([icUser]);
          previousSelectionRef.current = [icUser];

          // Call genie_team_dashboard API with the selected IC's emp code
          const callApi = async () => {
            try {
              setLoadingSummary(true);
              console.log(
                "[REDIRECTION API CALL] Calling with team_ids (IC):",
                [payload.selectedICEmpCode],
              );
              const response = await Axios.post(
                config.get("API_URL") + "/linkDashboard/link_team_dashboard",
                {
                  team_ids: [payload.selectedICEmpCode],
                  manager_code: [],
                  city_names: [],
                  store_codes: [],
                  segment: [],
                },
                {
                  headers: {
                    Authorization: ` ${localStorage.getItem("usertoken")}`,
                    "Content-Type": "application/json",
                  },
                },
              );
              console.log("[REDIRECTION API CALL] Response received");
              if (response && response.data) {
                if (response.data.data) {
                  setSummary(response.data.data);
                }
                if (
                  response.data.months &&
                  Array.isArray(response.data.months)
                ) {
                  setMonths(response.data.months);
                }
              }
            } catch (error) {
              console.error(
                "[REDIRECTION API CALL] Error fetching summary:",
                error,
              );
            } finally {
              setLoadingSummary(false);
            }
          };
          callApi();
          successfullyApplied = true;
        }
      }
    }
    // Case 2: Only userEmpCode (from Total Row in IC table) - show entire team
    else if (payload.userEmpCode) {
      console.log("[REDIRECTION EFFECT] Has userEmpCode:", payload.userEmpCode);
      // Select "All" in the team members filter since we're showing the entire team
      const allOption = { value: "all", label: "All" };
      if (userList.length > 0 && userList[0].value === "all") {
        console.log(
          "[REDIRECTION EFFECT] UserList ready, setting All and calling API",
        );
        setSelectedUsers([allOption]);
        previousSelectionRef.current = [allOption];

        // Directly call API with the userEmpCode to avoid multiple calls
        // We use the team_ids directly here without waiting for state updates
        const callApi = async () => {
          try {
            setLoadingSummary(true);
            console.log("[REDIRECTION API CALL] Calling with team_ids:", [
              payload.userEmpCode,
            ]);
            const response = await Axios.post(
              config.get("API_URL") + "/linkDashboard/link_team_dashboard",
              {
                team_ids: [payload.userEmpCode],
                manager_code: [],
                city_names: [],
                store_codes: [],
              },
              {
                headers: {
                  Authorization: ` ${localStorage.getItem("usertoken")}`,
                  "Content-Type": "application/json",
                },
              },
            );
            console.log("[REDIRECTION API CALL] Response received");
            if (response && response.data) {
              if (response.data.data) {
                setSummary(response.data.data);
              }
              if (response.data.months && Array.isArray(response.data.months)) {
                setMonths(response.data.months);
              }
            }
          } catch (error) {
            console.error(
              "[REDIRECTION API CALL] Error fetching summary:",
              error,
            );
          } finally {
            setLoadingSummary(false);
          }
        };
        callApi();
        successfullyApplied = true;
      }
    }
    // 2. Multiple ICs (legacy support)
    else if (
      payload.selectedICEmpCodes &&
      Array.isArray(payload.selectedICEmpCodes)
    ) {
      console.log(
        "[REDIRECTION EFFECT] Has selectedICEmpCodes:",
        payload.selectedICEmpCodes,
      );
      if (userList.length > 0) {
        const icUsers = userList.filter((user) =>
          payload.selectedICEmpCodes.includes(user.value),
        );
        if (icUsers.length > 0) {
          setSelectedUsers(icUsers);
          previousSelectionRef.current = icUsers;
          isFilterChangeRef.current = true;
          successfullyApplied = true;
        }
      }
    }
    // 3. Single IC (legacy support)
    else if (payload.selectedICEmpCode) {
      console.log(
        "[REDIRECTION EFFECT] Has selectedICEmpCode:",
        payload.selectedICEmpCode,
      );
      if (userList.length > 0) {
        const icUser = userList.find(
          (user) => String(user.value) === String(payload.selectedICEmpCode),
        );
        if (icUser) {
          setSelectedUsers([icUser]);
          previousSelectionRef.current = [icUser];
          isFilterChangeRef.current = true;
          successfullyApplied = true;
        }
      }
    }
    // 4. Store UTIDs
    else if (payload.selectedStoreUTIDs) {
      console.log(
        "[REDIRECTION EFFECT] Has selectedStoreUTIDs:",
        payload.selectedStoreUTIDs,
      );
      const storeObjects = payload.selectedStoreUTIDs.map((utid) => ({
        value: utid,
        label: utid,
      }));
      setSelectedStore(storeObjects);
      isFilterChangeRef.current = true;
      successfullyApplied = true;
    }
    // 5. No specific emp code provided (admin flow or default) - select All and load default data
    else if (userList.length > 0) {
      console.log(
        "[REDIRECTION EFFECT] No specific payload, defaulting to All",
      );
      const allOption = { value: "all", label: "All" };
      if (userList[0].value === "all") {
        setSelectedUsers([allOption]);
        previousSelectionRef.current = [allOption];
        isFilterChangeRef.current = true;
        successfullyApplied = true;
      }
    }

    if (successfullyApplied) {
      console.log(
        "[REDIRECTION EFFECT] Successfully applied, cleaning up payload",
      );
      redirectionPayloadRef.current = null;
      isRedirectionProcessingRef.current = false;
      hasCompletedRedirectionRef.current = true; // Mark that redirection is complete
      setCameFromSalesPerformance(true);
    }
  }, [userList]); // Only depend on userList, not on fetchSummaryWithTeamIds

  const customStyles = {
    control: (provided) => ({
      ...provided,
      padding: "0px",
      minHeight: "15px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "23px",
    }),
    clearIndicator: (provided) => ({
      ...provided,
      padding: "5px",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "5px",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0px 6px",
    }),
    menu: (styles) => ({ ...styles, zIndex: 999 }),
  };

  // Fetch managers using get-managers API
  const fetchManagers = useCallback(async (asoEmpCodes) => {
    const idsPayload = Array.isArray(asoEmpCodes) ? asoEmpCodes : [];
    try {
      setLoading(true);
      const response = await Axios.post(
        config.get("API_URL") + "/filters/genie_dashboard/get-link-managers",
        { manager_code: idsPayload },
        {
          headers: {
            Authorization: ` ${localStorage.getItem("usertoken")}`,
          },
        },
      );
      if (response && response.data) {
        // Format response for dropdown: API returns { emp_id, manager_name }
        const formattedData = response.data.map((manager) => ({
          value: manager.emp_id,
          label: manager.manager_name,
        }));
        setManagerList(formattedData);
      }
    } catch (error) {
      console.error("Error fetching managers:", error);
      setManagerList([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch team members based on aso_emp_code or manager selection
  const fetchTeamMembers = useCallback(
    async (asoEmpCodes, managerCodes = []) => {
      const idsPayload = Array.isArray(asoEmpCodes) ? asoEmpCodes : [];
      const managerCodesPayload = Array.isArray(managerCodes)
        ? managerCodes
        : [];
      try {
        setLoading(true);
        const response = await Axios.post(
          config.get("API_URL") + "/filters/genie_dashboard/get-link-team",
          { ids: idsPayload, manager_code: managerCodesPayload },
          {
            headers: {
              Authorization: ` ${localStorage.getItem("usertoken")}`,
            },
          },
        );
        if (response && response.data) {
          // Format response for dropdown: API returns { emp_id, person_name }
          const formattedData = response.data.map((user) => ({
            value: user.emp_id, // Use emp_id from API response
            label: user.person_name || `${user.emp_id}`,
            aso_emp_code: user.emp_id, // Map emp_id to aso_emp_code for consistency
            email: "", // Email not available from API
          }));
          // Add "All" option at the beginning (even if the list is empty)
          const allOption = { value: "all", label: "All" };
          const nextUserList = [allOption, ...formattedData];
          setUserList(nextUserList);

          // ONLY select "All" by default if we are NOT in a redirection process
          // and NO users are currently selected.
          if (
            !isRedirectionProcessingRef.current &&
            selectedUsers.length === 0
          ) {
            setSelectedUsers([allOption]);
            previousSelectionRef.current = [allOption];
          }
        }
      } catch (error) {
        console.error("Error fetching team members:", error);
        setUserList([]);
      } finally {
        setLoading(false);
      }
    },
    [selectedUsers],
  );

  // Fetch stores based on aso_emp_codes
  const fetchStores = useCallback(async (asoEmpCodes) => {
    // Allow API call with empty array for initial page load when no aso_emp_code
    if (!asoEmpCodes) {
      setStoreList([]);
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      const response = await Axios.post(
        config.get("API_URL") + "/filters/genie_dashboard/get-link-store",
        { ids: asoEmpCodes },
        {
          headers: {
            Authorization: ` ${localStorage.getItem("usertoken")}`,
          },
        },
      );
      if (response && response.data) {
        // Format response for dropdown: API returns { store_name, store_code }
        const formattedData = response.data.map((store) => ({
          value: store.store_code || store.store_name,
          label: store.store_name || store.store_code,
          city: null, // City not available from API
        }));
        setStoreList(formattedData);
      }
    } catch (error) {
      setStoreList([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch cities based on aso_emp_codes
  const fetchCities = useCallback(async (asoEmpCodes) => {
    // Allow API call with empty array for initial page load when no aso_emp_code
    // The backend should handle empty arrays gracefully
    if (!asoEmpCodes) {
      setCityList([]);
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      const response = await Axios.post(
        config.get("API_URL") + "/filters/genie_dashboard/get-link-city",
        { ids: asoEmpCodes },
        {
          headers: {
            Authorization: ` ${localStorage.getItem("usertoken")}`,
          },
        },
      );
      if (response && response.data) {
        // Format response for dropdown: API returns { city }
        const formattedData = response.data.map((city) => ({
          value: city.city,
          label: city.city,
        }));
        setCityList(formattedData);
      }
    } catch (error) {
      setCityList([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // Calculate available stores based on selected team members
  const availableStores = useMemo(() => {
    return storeList;
  }, [storeList]);

  // Calculate available cities based on selected team members
  const availableCities = useMemo(() => {
    return cityList;
  }, [cityList]);

  // Handle managers selection change
  const handleManagersChange = async (selectedOptions) => {
    const newSelection = selectedOptions || [];
    setSelectedManagers(newSelection);

    // Clear dependent filters
    setSelectedUsers([]);
    previousSelectionRef.current = [];
    setSelectedStore([]);

    // Note: We do NOT set isFilterChangeRef.current = true here because we call
    // fetchSummaryWithTeamIds directly below. Setting the flag would cause
    // the FILTER CHANGE EFFECT to also call fetchSummary, resulting in duplicate API calls.

    // Fetch team members based on selected managers
    // Note: fetchStores and fetchCities will be called by handleTeamMembersChange
    // or when the user selects team members, using the IC emp_ids
    if (newSelection.length > 0) {
      const managerCodes = newSelection.map((m) => m.value);
      // Pass empty array for ids and manager codes as second parameter
      await fetchTeamMembers([], managerCodes);
    } else {
      // No managers selected - fetch based on user's aso_emp_code
      if (asoEmpCode) {
        await fetchTeamMembers([asoEmpCode], []);
      } else {
        await fetchTeamMembers([], []);
      }
    }

    // Refresh summary - use manager codes if selected, otherwise use asoEmpCode
    const managerCodes =
      newSelection.length > 0 ? newSelection.map((m) => m.value) : [];
    const effectiveIds =
      newSelection.length > 0
        ? [] // When managers are selected, don't pass team_ids
        : asoEmpCode
          ? [asoEmpCode]
          : [];

    await fetchSummaryWithTeamIds(effectiveIds, [], [], managerCodes);
  };

  // Handle "All" selection logic for team members dropdown
  const handleTeamMembersChange = async (selectedOptions) => {
    const newOptions = selectedOptions || [];
    const oldAllSelected = selectedUsers.some((u) => u.value === "all");
    const newAllSelected = newOptions.some((u) => u.value === "all");
    const previousSelection = previousSelectionRef.current;

    let finalSelection = [];

    if (!oldAllSelected && newAllSelected) {
      // Case 1: "All" was just selected - select only "All"
      finalSelection = [{ value: "all", label: "All" }];
    } else if (oldAllSelected && !newAllSelected) {
      // Case 2: "All" was selected, and user clicked a specific member
      // ReactMultiSelectCheckboxes might select all members when "All" is deselected
      // We need to detect this and keep only the clicked member
      const nonAllOptions = newOptions.filter((u) => u.value !== "all");
      const previousNonAll = previousSelection.filter((u) => u.value !== "all");

      // If all members were auto-selected (count matches total user list minus "All"),
      // ReactMultiSelectCheckboxes selected all. We should keep only the LAST one
      // (which is typically the one that was clicked to deselect "All")
      if (nonAllOptions.length >= userList.length - 1) {
        // All members were auto-selected - keep only the last one (the clicked member)
        finalSelection = [nonAllOptions[nonAllOptions.length - 1]];
      } else {
        // Normal case: some members were selected (not all)
        // Keep only the newly added ones if we can detect them, otherwise keep all
        const newlyAdded = nonAllOptions.filter(
          (newOpt) =>
            !previousNonAll.some((prev) => prev.value === newOpt.value),
        );
        // If we can detect newly added, use those; otherwise use all non-"all" options
        finalSelection = newlyAdded.length > 0 ? newlyAdded : nonAllOptions;
      }
    } else if (oldAllSelected && newAllSelected && newOptions.length > 1) {
      // Case 2b: "All" was selected, user clicked another option while "All" is still there
      // Remove "All" and keep only the specific members
      finalSelection = newOptions.filter((u) => u.value !== "all");
    } else if (newOptions.length === 0) {
      // Case 3: Everything was de-selected
      finalSelection = [];
    } else {
      // Case 4: Normal selection (no "All" involved)
      finalSelection = newOptions;
    }

    // Update the ref for next comparison
    previousSelectionRef.current = finalSelection;

    setSelectedUsers(finalSelection);
    // Clear store and city filters when team selection changes
    setSelectedStore([]); // Reset store filter

    // Note: We do NOT set isFilterChangeRef.current = true here because we call
    // fetchSummaryWithTeamIds directly below. Setting the flag would cause
    // the FILTER CHANGE EFFECT to also call fetchSummary, resulting in duplicate API calls.

    // --- Logic for fetching stores/cities based on selection ---
    const allIsSelected = finalSelection.some((u) => u.value === "all");
    const noSelection = finalSelection.length === 0;

    if (allIsSelected || noSelection) {
      // If "All" is selected or no one is selected, fetch based on user's aso_emp_code
      if (asoEmpCode) {
        await Promise.all([
          fetchStores([asoEmpCode]),
          fetchCities([asoEmpCode]),
        ]);
      } else {
        // If no aso_emp_code, call APIs with empty array to refresh lists
        await Promise.all([fetchStores([]), fetchCities([])]);
      }
    } else {
      // Fetch based on specific team members selected - use the emp_id from API response
      // The value is already the emp_id from the API response
      const selectedEmpIds = finalSelection
        .map((selected) => selected.value) // value is the emp_id from API
        .filter((id) => id && id !== "all");

      if (selectedEmpIds.length > 0) {
        await Promise.all([
          fetchStores(selectedEmpIds),
          fetchCities(selectedEmpIds),
        ]);
      } else {
        // Fallback in case something weird happens
        if (asoEmpCode) {
          await Promise.all([
            fetchStores([asoEmpCode]),
            fetchCities([asoEmpCode]),
          ]);
        } else {
          // If no aso_emp_code, call APIs with empty array to refresh lists
          await Promise.all([fetchStores([]), fetchCities([])]);
        }
      }
    }

    // Refresh summary after team selection changes
    // Calculate team_ids directly from finalSelection (not from state which may be stale)
    const allIsSelectedForAPI = finalSelection.some((u) => u.value === "all");
    const team_ids_for_api = allIsSelectedForAPI
      ? []
      : finalSelection.map((u) => u.value).filter((id) => id && id !== "all");

    // Use the calculated team_ids directly, not from state
    const effectiveTeamIds =
      team_ids_for_api.length === 0 && asoEmpCode
        ? [asoEmpCode]
        : team_ids_for_api;

    // Call fetchSummary with explicit team_ids and empty store/city arrays
    // Pass empty arrays explicitly since we just cleared them and state may not be updated yet
    await fetchSummaryWithTeamIds(effectiveTeamIds, [], []);
  };

  // -------- Summary (Level 1) API ---------
  const buildFiltersPayload = useCallback(() => {
    const allSelected = selectedUsers.some((u) => u.value === "all");

    // If "All" is selected, we send an empty array for team_ids,
    // and let fetchSummary use the root asoEmpCode
    const team_ids = allSelected
      ? []
      : (selectedUsers || [])
          .map((u) => {
            // Use the value directly (which is the emp_id from API response)
            return u.value;
          })
          .filter((id) => id && id !== "all");

    const manager_code = selectedManagers
      ? Array.isArray(selectedManagers)
        ? selectedManagers.map((m) => m.value)
        : [selectedManagers.value]
      : [];

    const city_names = selectedCity
      ? Array.isArray(selectedCity)
        ? selectedCity.map((c) => c.value || c.label || c)
        : [selectedCity.value || selectedCity.label || selectedCity]
      : [];

    const store_codes = selectedStore
      ? Array.isArray(selectedStore)
        ? selectedStore.map((s) => s.value || s.label || s)
        : [selectedStore.value || selectedStore.label || selectedStore]
      : [];

    const payload = { team_ids, manager_code, city_names, store_codes };
    return payload;
  }, [selectedUsers, selectedManagers, selectedCity, selectedStore, userList]);

  // Helper function to fetch summary with explicit team_ids (bypasses state)
  const fetchSummaryWithTeamIds = useCallback(
    async (
      explicitTeamIds,
      explicitStoreCodes = null,
      explicitCityNames = null,
      explicitManagerCodes = null,
    ) => {
      console.log(
        "[fetchSummaryWithTeamIds] Called with team_ids:",
        explicitTeamIds,
        "store_codes:",
        explicitStoreCodes,
        "city_names:",
        explicitCityNames,
        "manager_code:",
        explicitManagerCodes,
      );
      try {
        setLoadingSummary(true);
        // Use explicit values if provided, otherwise get from current state
        const city_names =
          explicitCityNames !== null
            ? explicitCityNames
            : selectedCity
              ? Array.isArray(selectedCity)
                ? selectedCity.map((c) => c.value || c.label || c)
                : [selectedCity.value || selectedCity.label || selectedCity]
              : [];

        const store_codes =
          explicitStoreCodes !== null
            ? explicitStoreCodes
            : selectedStore
              ? Array.isArray(selectedStore)
                ? selectedStore.map((s) => s.value || s.label || s)
                : [selectedStore.value || selectedStore.label || selectedStore]
              : [];

        const manager_code =
          explicitManagerCodes !== null
            ? explicitManagerCodes
            : selectedManagers
              ? Array.isArray(selectedManagers)
                ? selectedManagers.map((m) => m.value)
                : [selectedManagers.value]
              : [];

        const requestPayload = {
          team_ids: explicitTeamIds || [],
          manager_code,
          city_names,
          store_codes,
        };

        console.log("[fetchSummaryWithTeamIds] API Request:", {
          explicitTeamIds,
          manager_code,
          city_names,
          store_codes,
          note:
            explicitTeamIds.length === 0
              ? "Using asoEmpCode"
              : "Using selected emp_ids",
        });

        const response = await Axios.post(
          config.get("API_URL") + "/linkDashboard/link_team_dashboard",
          requestPayload,
          {
            headers: {
              Authorization: ` ${localStorage.getItem("usertoken")}`,
              "Content-Type": "application/json",
            },
          },
        );
        if (response && response.data) {
          if (response.data.data) {
            setSummary(response.data.data);
          }
          // Store months from API response
          if (response.data.months && Array.isArray(response.data.months)) {
            setMonths(response.data.months);
          }
        }
      } catch (error) {
        console.error("Error fetching summary:", error);
        console.error("Error details:", error.response?.data || error.message);
      } finally {
        setLoadingSummary(false);
      }
    },
    [selectedCity, selectedStore, selectedManagers],
  );

  const fetchSummary = useCallback(async () => {
    console.log("[fetchSummary] Called");
    try {
      setLoadingSummary(true);
      const { team_ids, manager_code, city_names, store_codes } =
        buildFiltersPayload();
      // If no team selected yet (team_ids is empty), fallback to user's aso_emp_code
      // This should only happen when "All" is selected or nothing is selected
      const effectiveTeamIds =
        team_ids.length === 0 && asoEmpCode ? [asoEmpCode] : team_ids;

      const requestPayload = {
        team_ids: effectiveTeamIds,
        manager_code,
        city_names,
        store_codes,
      };

      console.log("[fetchSummary] API Request:", requestPayload);

      const response = await Axios.post(
        config.get("API_URL") + "/linkDashboard/link_team_dashboard",
        requestPayload,
        {
          headers: {
            Authorization: ` ${localStorage.getItem("usertoken")}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (response && response.data) {
        if (response.data.data) {
          setSummary(response.data.data);
        }
        // Store months from API response
        if (response.data.months && Array.isArray(response.data.months)) {
          setMonths(response.data.months);
        }
      }
    } catch (error) {
      console.error("Error fetching summary:", error);
      console.error("Error details:", error.response?.data || error.message);
    } finally {
      setLoadingSummary(false);
    }
  }, [buildFiltersPayload, asoEmpCode]);

  // Handlers to update store/city and refresh summary

  const handleStoreChange = (val) => {
    isFilterChangeRef.current = true;
    setSelectedStore(val);
    // fetchSummary will be called by useEffect after state updates
  };
  const handleCityChange = (val) => {
    isFilterChangeRef.current = true;
    setSelectedCity(val);
    // fetchSummary will be called by useEffect after state updates
  };

  // Use ref to track if bootstrap summary has been called to prevent multiple calls
  const hasBootstrapCalledRef = useRef(false);

  // Initial bootstrap: after aso_emp_code is known and lists are fetched, fetch summary
  useEffect(() => {
    console.log(
      "[BOOTSTRAP EFFECT] tokenReady:",
      tokenReady,
      "isRedirectionProcessingRef:",
      isRedirectionProcessingRef.current,
      "redirectionPayloadRef:",
      redirectionPayloadRef.current,
      "location.state?.fromSalesPerformance:",
      location.state?.fromSalesPerformance,
      "isFilterChangeRef:",
      isFilterChangeRef.current,
      "hasCompletedRedirection:",
      hasCompletedRedirectionRef.current,
      "hasBootstrapCalled:",
      hasBootstrapCalledRef.current,
    );
    if (!tokenReady) return;

    // Skip if bootstrap has already been called
    if (hasBootstrapCalledRef.current) {
      console.log("[BOOTSTRAP EFFECT] Skipping - bootstrap already called");
      return;
    }

    // If redirection is in progress, do NOT fetch with defaults.
    // The redirection effect will handle state updates and the isFilterChangeRef logic will trigger the fetch.
    if (
      isRedirectionProcessingRef.current ||
      redirectionPayloadRef.current ||
      (location.state && location.state.fromSalesPerformance)
    ) {
      console.log("[BOOTSTRAP EFFECT] Skipping - redirection in progress");
      return;
    }

    // Skip if redirection was just completed - the redirection effect already called the API
    if (hasCompletedRedirectionRef.current) {
      console.log("[BOOTSTRAP EFFECT] Skipping - redirection just completed");
      return;
    }

    // Skip if this is a filter change (handled by separate useEffect)
    if (isFilterChangeRef.current) {
      console.log("[BOOTSTRAP EFFECT] Skipping - filter change in progress");
      return;
    }

    console.log("[BOOTSTRAP EFFECT] Calling fetchSummary");
    hasBootstrapCalledRef.current = true;
    fetchSummary();
  }, [tokenReady, fetchSummary, location.state]);

  // Watch for filter changes and fetch summary
  // This handles store/city filter changes (team member changes are handled in handleTeamMembersChange)
  useEffect(() => {
    console.log(
      "[FILTER CHANGE EFFECT] tokenReady:",
      tokenReady,
      "isFilterChangeRef:",
      isFilterChangeRef.current,
    );
    if (!tokenReady) return;
    // Only handle filter changes if the flag is set
    if (isFilterChangeRef.current) {
      console.log(
        "[FILTER CHANGE EFFECT] Filter change detected, calling fetchSummary after timeout",
      );
      // Call fetchSummary after state has updated, then reset the flag
      const timer = setTimeout(async () => {
        await fetchSummary();
        isFilterChangeRef.current = false;
      }, 0);
      return () => clearTimeout(timer);
    }
  }, [selectedUsers, selectedStore, selectedCity, tokenReady, fetchSummary]);

  // -------- Level 2 (Terminals) API ---------
  const fetchTerminals = useCallback(
    async (flag, searchValue = null, page = null) => {
      // Cancel any pending request before starting a new one
      if (terminalsAbortControllerRef.current) {
        terminalsAbortControllerRef.current.abort();
      }
      // Create a new AbortController for this request
      const abortController = new AbortController();
      terminalsAbortControllerRef.current = abortController;

      try {
        setLoadingDetails(true);
        const { team_ids, manager_code, city_names, store_codes } =
          buildFiltersPayload();
        const effectiveTeamIds =
          team_ids.length === 0 && asoEmpCode ? [asoEmpCode] : team_ids;

        // Use searchValue parameter if provided, otherwise use state
        const queryToUse = searchValue !== null ? searchValue : searchQuery;

        const payload = {
          draw: 1,
          start: ((page ?? currentPage) - 1) * rowsPerPage,
          length: rowsPerPage,
          search: { value: queryToUse || "", regex: false },
          flag, // "transacting" | "non-transacting"
          team_ids: effectiveTeamIds,
          manager_code,
          city_names,
          store_codes,
        };

        const url =
          config.get("API_URL") +
          "/linkDashboard/link_transacting_non_transacting_merchants";

        const response = await Axios.post(url, payload, {
          headers: {
            Authorization: ` ${localStorage.getItem("usertoken")}`,
            "Content-Type": "application/json",
          },
          signal: abortController.signal, // Pass the abort signal
        });

        // Check if this request was cancelled (user navigated away)
        if (abortController.signal.aborted) {
          console.log(
            "[fetchTerminals] Request was cancelled, ignoring response",
          );
          return;
        }

        const rows = response?.data?.data || [];

        if (response?.data?.recordsTotal != null) {
          setTotalRecords(Number(response.data.recordsTotal));
        } else {
          setTotalRecords(0);
        }

        // Store months from API response if available
        if (response?.data?.months && Array.isArray(response.data.months)) {
          setMonths(response.data.months);
        }
        // map API data
        const mapped = rows.map((r) => ({
          utid: r["Mobile"] ?? "-",
          storeName: r["Store Name"] ?? "-",
          mobile: r["Mobile"] ?? "-",
          city: r["City Name"] ?? "-",
          currentMdr: r["Current Month Slab"] ?? "-",
          currentVol:
            r["Current Month GTV (Lakhs)"] != null
              ? r["Current Month GTV (Lakhs)"]
              : (r["Current Month GTV (Rs.)"] ?? "-"),
          m1Vol:
            r["Previous Month GTV (Lakhs)"] != null
              ? r["Previous Month GTV (Lakhs)"]
              : (r["Previous Month GTV (Rs.)"] ?? "-"),
          m2Vol:
            r["Previous to Previous Month GTV (Lakhs)"] != null
              ? r["Previous to Previous Month GTV (Lakhs)"]
              : (r["Previous to Previous Month GTV (Rs.)"] ?? "-"),
        }));

        setDetailedData(mapped);
        setShowDetailTable(true);
        setShowStoreDashboard(false);
      } catch (error) {
        // Ignore cancelled request errors
        if (
          Axios.isCancel(error) ||
          error.name === "AbortError" ||
          error.name === "CanceledError"
        ) {
          console.log("[fetchTerminals] Request cancelled");
          return;
        }
        console.error("Error fetching terminals (Level 2):", error);
        setDetailedData([]);
        setTotalRecords(0);
        setShowDetailTable(true);
        setShowStoreDashboard(false);
      } finally {
        // Only clear loading if this request wasn't cancelled
        if (!abortController.signal.aborted) {
          setLoadingDetails(false);
        }
      }
    },
    [buildFiltersPayload, asoEmpCode, currentPage, rowsPerPage],
  );

  // Compute first table data from summary API response
  const tierWiseTotalData = useMemo(() => {
    if (!summary) {
      return [
        {
          Tier: "Total allocated stores",
          currentMonth: "-",
          lmtd: "-",
          previousMonth: "-",
          previousToPreviousMonth: "-",
          isClickable: false,
        },

        {
          Tier: "# Link Users",
          currentMonth: "-",
          lmtd: "-",
          previousMonth: "-",
          previousToPreviousMonth: "-",
          isClickable: false,
        },
        {
          Tier: "UTIDs/Users Transacting",
          currentMonth: "-",
          lmtd: "-",
          previousMonth: "-",
          previousToPreviousMonth: "-",
          isClickable: true,
        },
        {
          Tier: "UTIDs/Users Non-Transacting",
          currentMonth: "-",
          lmtd: "-",
          previousMonth: "-",
          previousToPreviousMonth: "-",
          isClickable: true,
        },
        {
          Tier: "Transacting %",
          currentMonth: "-",
          lmtd: "-",
          previousMonth: "-",
          previousToPreviousMonth: "-",
          isClickable: false,
        },
      ];
    }

    return [
      {
        Tier: "Total allocated stores",
        currentMonth: summary.current_month_total_allocated_stores || 0,
        lmtd: summary.current_month_total_allocated_stores_lmtd ?? "-",
        previousMonth: summary.previous_month_total_allocated_stores || 0,
        previousToPreviousMonth:
          summary.previous_previous_month_total_allocated_stores || 0,
        isClickable: false,
      },

      {
        Tier: "# Link Users",
        currentMonth: summary.current_month_link_users || 0,
        lmtd: summary.current_month_link_users_lmtd ?? "-",
        previousMonth: summary.previous_month_link_users || 0,
        previousToPreviousMonth:
          summary.previous_previous_month_link_users || 0,
        isClickable: false,
      },
      {
        Tier: "UTIDs/Users Transacting",
        currentMonth: summary.current_month_transacting || 0,
        lmtd: summary.current_month_transacting_lmtd ?? "-",
        previousMonth: summary.previous_month_transacting || 0,
        previousToPreviousMonth:
          summary.previous_previous_month_transacting || 0,
        isClickable: true,
        isParameterBlue: true, // Make parameter blue
      },
      {
        Tier: "UTIDs/Users Non-Transacting",
        currentMonth: summary.current_month_non_transacting || 0,
        lmtd: summary.current_month_non_transacting_lmtd ?? "-",
        previousMonth: summary.previous_month_non_transacting || 0,
        previousToPreviousMonth:
          summary.previous_previous_month_non_transacting || 0,
        isClickable: true,
        isParameterBlue: true, // Make parameter blue
      },
      {
        Tier: "Transacting %",
        currentMonth: summary.current_month_transacting_percentage
          ? `${summary.current_month_transacting_percentage}%`
          : "0%",
        lmtd: summary.current_month_transacting_percentage_lmtd != null
          ? `${summary.current_month_transacting_percentage_lmtd}%`
          : "-",
        previousMonth: summary.previous_month_transacting_percentage
          ? `${summary.previous_month_transacting_percentage}%`
          : "0%",
        previousToPreviousMonth:
          summary.previous_previous_month_transacting_percentage
            ? `${summary.previous_previous_month_transacting_percentage}%`
            : "0%",
        isClickable: false,
      },
    ];
  }, [summary]);

  // Compute second table data from summary API response
  const secondTableData = useMemo(() => {
    if (!summary) {
      return [
        {
          Parameter: "Link GTV (Rs. Lakhs)",
          currentMonth: "-",
          previousMonth: "-",
          previousToPreviousMonth: "-",
        },

        {
          Parameter: "New Merchants Acquired",
          currentMonth: "-",
          previousMonth: "-",
          previousToPreviousMonth: "-",
        },
      ];
    }

    return [
      {
        Parameter: "Link GTV (Rs. Lakhs)",
        currentMonth: summary.current_month_link_gtv_lakhs || 0,
        lmtd: summary.current_month_link_gtv_lmtd_lakhs || 0,
        previousMonth: summary.previous_month_link_gtv_lakhs || 0,
        previousToPreviousMonth:
          summary.previous_previous_month_link_gtv_lakhs || 0,
      },

      {
        Parameter: "New Merchants Acquired",
        currentMonth: summary.current_month_new_merchants_acquired || 0,
        lmtd: summary.current_month_new_merchants_lmtd || 0,
        previousMonth: summary.previous_month_new_merchants_acquired || 0,
        previousToPreviousMonth:
          summary.previous_previous_month_new_merchants_acquired || 0,
      },
    ];
  }, [summary]);

  // Hook to get month labels from API response
  const monthLabels = useMemo(() => {
    // Use months from API if available, otherwise calculate fallback
    if (months && months.length >= 3) {
      return {
        current: months[0] || "",
        prev: months[1] || "",
        prevPrev: months[2] || "",
      };
    }

    // Fallback calculation if API months not available yet
    const options = { month: "short" };
    const today = new Date();
    const year = today.getFullYear().toString().slice(-2);

    const current = today.toLocaleString("en-US", options) + "-" + year;

    const prevMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const prevYear = prevMonth.getFullYear().toString().slice(-2);
    const prev = prevMonth.toLocaleString("en-US", options) + "-" + prevYear;

    const prevPrevMonth = new Date(
      today.getFullYear(),
      today.getMonth() - 2,
      1,
    );
    const prevPrevYear = prevPrevMonth.getFullYear().toString().slice(-2);
    const prevPrev =
      prevPrevMonth.toLocaleString("en-US", options) + "-" + prevPrevYear;

    return {
      current: current,
      prev: prev,
      prevPrev: prevPrev,
    };
  }, [months]);

  // Use ref to store the latest search query to avoid stale closures
  const searchQueryRef = useRef("");

  // Update ref whenever searchQuery changes (this doesn't trigger API calls)
  useEffect(() => {
    searchQueryRef.current = searchQuery;
  }, [searchQuery]);

  // Use ref to track if search was triggered by Enter key to prevent double calls
  const isSearchTriggeredByEnter = useRef(false);
  // Use ref to track if this is the initial load of the detail table (to prevent double API call)
  const isInitialDetailTableLoad = useRef(false);

  useEffect(() => {
    if (showDetailTable) {
      const flag =
        terminalType === "Transacting Terminal(s)"
          ? "transacting"
          : "non-transacting";

      if (isSearchTriggeredByEnter.current) {
        // If triggered by Enter, the fetchTerminals was already called with search query
        // Just reset the flag and return
        isSearchTriggeredByEnter.current = false;
        return;
      }

      // Skip the first call when the detail table is initially shown,
      // as handleCurrentMonthClick already called fetchTerminals
      if (isInitialDetailTableLoad.current) {
        isInitialDetailTableLoad.current = false;
        return;
      }

      // For page/filter changes, use the current search query from ref
      // This maintains the search query when user changes pages or filters
      fetchTerminals(flag, searchQueryRef.current);
    }
  }, [currentPage, showDetailTable, terminalType, fetchTerminals]); // Removed searchQuery - search only on Enter

  useEffect(() => {
    // Prevent this effect from running multiple times
    if (hasInitializedRef.current) return;
    hasInitializedRef.current = true;

    const token = localStorage.getItem("usertoken");
    if (token) {
      try {
        const decoded = jwt_decode(token);
        const isIC = !!decoded?.aso_emp_code;
        setIsICUser(isIC);

        let asoEmpCodeValue = decoded?.aso_emp_code || null;

        // Check if coming from Sales Performance with a specific userEmpCode
        if (
          redirectionPayloadRef.current &&
          redirectionPayloadRef.current.userEmpCode
        ) {
          // Use the passed userEmpCode as the team_id for API calls
          asoEmpCodeValue = redirectionPayloadRef.current.userEmpCode;
        }

        // Track main dashboard view
        trackUserActivity("link_team_dashsboard");

        setAsoEmpCode(asoEmpCodeValue);

        // Determine what IDs to use for filter APIs (get-team, get-store, get-city)
        // For admin users (no aso_emp_code in token), don't send any IDs - call with empty array
        // For manager users, use their asoEmpCode or the passed userEmpCode
        let filterIds = [];

        // Check if user is admin (no aso_emp_code AND no manager_of_aso in token)
        const isAdminUser = !decoded?.aso_emp_code && !decoded?.manager_of_aso;

        if (isAdminUser) {
          // Admin user - don't send any IDs for filter APIs, even when clicking on IC
          // This ensures admin sees all team members/stores/cities
          console.log(
            "[INIT] Admin user detected - calling filter APIs with empty array",
          );
          filterIds = [];
        } else if (decoded?.manager_of_aso) {
          // Manager user - use manager_of_aso code for filter APIs
          filterIds = [decoded.manager_of_aso];
        } else if (asoEmpCodeValue) {
          // IC user - use their aso_emp_code for filter APIs
          filterIds = [asoEmpCodeValue];
        }

        // Always call filter APIs on initial page load with the determined filterIds
        if (filterIds.length > 0) {
          fetchManagers(filterIds);
          fetchTeamMembers(filterIds);
          fetchStores(filterIds);
          fetchCities(filterIds);
        } else {
          // Call APIs with empty array to fetch all available data (admin users)
          fetchManagers([]);
          fetchTeamMembers([]);
          fetchStores([]);
          fetchCities([]);
        }
      } catch (error) {
        console.error("Error decoding token:", error);
      } finally {
        setTokenReady(true);
      }
    } else {
      setAsoEmpCode(null);
      setUserList([]);
      // Call filter APIs even when no token
      fetchManagers([]);
      fetchTeamMembers([]);
      fetchStores([]);
      fetchCities([]);
      setTokenReady(true);
    }
  }, [fetchManagers, fetchTeamMembers, fetchStores, fetchCities]);

  // Fetch Store Dashboard Data by UTID
  const fetchStoreDashboardData = useCallback(async (utid) => {
    if (!utid) return;
    try {
      setLoadingStoreDashboard(true);
      setStoreDashboardData(null);
      const url =
        config.get("API_URL") + "/linkDashboard/link_store_dashboard";
      const payload = { mobile: utid };
      const response = await Axios.post(url, payload, {
        headers: {
          Authorization: ` ${localStorage.getItem("usertoken")}`,
          "Content-Type": "application/json",
        },
      });
      const apiData = response?.data?.data;
      if (!apiData) {
        setStoreDashboardData(null);
        return;
      }
      const storeInfo = apiData.store_info || {};
      const tx = apiData.transaction_dashboard || {};
      const brands = apiData.brand_dashboard || {};

      const support = apiData.support || {};
      const visits = apiData.sales_visits || {};
      const monthlyTargets = apiData.monthly_targets || {};
      const last3Visits = apiData.last_3_visits || {};
      const apiMonths = response?.data?.months || [];

      const valueOrZero = (v) => (v == null ? 0 : v);



      const brandNames = [
        "samsung",
        "vivo",
        "oppo",
        "xiaomi",
        "realme",
        "others",
        "total",
      ];
      const capitalize = (s) =>
        typeof s === "string" && s.length > 0
          ? s.charAt(0).toUpperCase() + s.slice(1)
          : s;
      const brandDashboard = brandNames.map((b) => ({
        parameter: capitalize(b),
        currentMonthVol: valueOrZero(brands.current_month?.[b]?.volume),
        currentMonthCount: valueOrZero(brands.current_month?.[b]?.count),
        previousMonthVol: valueOrZero(brands.previous_month?.[b]?.volume),
        previousMonthCount: valueOrZero(brands.previous_month?.[b]?.count),
        previousToPreviousVol: valueOrZero(
          brands.previous_previous_month?.[b]?.volume,
        ),
        previousToPreviousCount: valueOrZero(
          brands.previous_previous_month?.[b]?.count,
        ),
      }));

      const normalizedLast3Visits = Array.isArray(last3Visits)
        ? last3Visits
        : {
            currentMonth: Array.isArray(last3Visits.current_month)
              ? last3Visits.current_month
              : [],
            previousMonth: Array.isArray(last3Visits.previous_month)
              ? last3Visits.previous_month
              : [],
            previousToPreviousMonth: Array.isArray(
              last3Visits.previous_previous_month,
            )
              ? last3Visits.previous_previous_month
              : [],
          };

      const mapped = {
        storeName: storeInfo.store_name || "Store",
        utid: utid,
        phone: storeInfo.phone || "",
        fullAddress:
          storeInfo.store_address ||
          [storeInfo.store_name, storeInfo.city_name]
            .filter(Boolean)
            .join(", "),
        transactionDashboard: tx,
        brandDashboard,
        support: {
          currentMonth: {
            totalTickets: valueOrZero(support.current_month?.total_tickets),
            closedWithinTAT: valueOrZero(
              support.current_month?.closed_within_tat,
            ),
          },
          previousMonth: {
            totalTickets: valueOrZero(support.previous_month?.total_tickets),
            closedWithinTAT: valueOrZero(
              support.previous_month?.closed_within_tat,
            ),
          },
          previousPreviousMonth: {
            totalTickets: valueOrZero(
              support.previous_previous_month?.total_tickets,
            ),
            closedWithinTAT: valueOrZero(
              support.previous_previous_month?.closed_within_tat,
            ),
          },
        },

        salesVisits: {
          currentMonth: valueOrZero(visits.current_month),
          previousMonth: valueOrZero(visits.previous_month),
          previousToPrevious: valueOrZero(visits.previous_previous_month),
        },
        monthlyTargets: {
          currentMonth: {
            totalGtvTarget: valueOrZero(
              monthlyTargets.current_month?.total_gtv_target,
            ),
          },
          previousMonth: {
            totalGtvTarget: valueOrZero(
              monthlyTargets.previous_month?.total_gtv_target,
            ),
          },
          previousToPreviousMonth: {
            totalGtvTarget: valueOrZero(
              monthlyTargets.previous_previous_month?.total_gtv_target,
            ),
          },
        },
        last3Visits: normalizedLast3Visits,
        months: apiMonths, // Store months from API
      };

      setStoreDashboardData(mapped);
    } catch (error) {
      console.error("Error fetching store dashboard:", error);
      console.error("Error details:", error.response?.data || error.message);
      setStoreDashboardData(null);
    } finally {
      setLoadingStoreDashboard(false);
    }
  }, []);

  // ---------- Handlers ----------
  const handleCurrentMonthClick = async (tier) => {
    setCurrentPage(1);
    setTotalRecords(0);
    setDetailedData([]);
    // Mark that this is an initial load so the useEffect doesn't duplicate the API call
    isInitialDetailTableLoad.current = true;

    if (tier === "UTIDs/Users Transacting") {
      setTerminalType("Transacting Terminal(s)");
      trackUserActivity("link_team_dashsboard_trasacting");
      await fetchTerminals("transacting", null, 1);
    } else if (tier === "UTIDs/Users Non-Transacting") {
      setTerminalType("Non-Transacting Terminal(s)");
      trackUserActivity("link_team_dashsboard_nontrasacting");
      await fetchTerminals("non-transacting", null, 1);
    }
  };

  const handleUtidClick = (utid) => {
    setSelectedUtid(utid);
    setShowStoreDashboard(true);
    setStoreDashboardData(null);
    trackUserActivity("link_team_dashsboard_store_details");
    fetchStoreDashboardData(utid);
  };

  const handleBack = () => {
    // Cancel any pending terminal API calls to prevent race conditions
    if (terminalsAbortControllerRef.current) {
      terminalsAbortControllerRef.current.abort();
      terminalsAbortControllerRef.current = null;
    }
    // Also clear loading state immediately when navigating back
    setLoadingDetails(false);

    if (showStoreDashboard) {
      setShowStoreDashboard(false);
      setSelectedUtid(null);
    } else if (showDetailTable) {
      setShowDetailTable(false);
      // Clear search query of second page
      setSearchQuery("");
      searchQueryRef.current = "";
    }
  };

  // Handle back to Sales Performance Dashboard
  const handleBackToSalesPerformance = () => {
    history.push({
      pathname: "/admin/sales-performance-dashboard",
      state: {
        returnToICTable: true,
        fromTeamDashboard: true,
      },
    });
  };

  // Render header title based on current view
  const renderHeaderTitle = () => {
    if (showStoreDashboard && storeDashboardData) {
      // Store dashboard: show store name, phone, and address
      return (
        <div className="header-store-title">
          {/* Main title (large) */}
          <span className="store-name">
            {storeDashboardData.storeName} ({storeDashboardData.utid})
          </span>
          {/* Phone number (second line) */}
          {storeDashboardData.phone && (
            <a
              className="store-phone"
              href={`tel:${storeDashboardData.phone}`}
              style={{
                display: "block",
                fontSize: "0.9rem",
                marginTop: "4px",
                color: "#0d6efd",
                textDecoration: "none",
              }}
            >
              {storeDashboardData.phone}
            </a>
          )}
          {/* Address (third line) */}
          <span
            className="store-address"
            style={{ display: "block", fontSize: "0.8rem", marginTop: "4px" }}
          >
            {storeDashboardData.fullAddress}
          </span>
        </div>
      );
    }
    if (showDetailTable) {
      return terminalType;
    }
    return "My Dashboard";
  };

  const formatTargetValue = (value) => (value === 0 ? "-" : (value ?? "-"));

  const tireWiseTotal = tierWiseTotalData.map((data, index) => {
    // Map target values based on row type
    let targetValue = "-";
    if (summary) {
      if (data.Tier === "UTIDs/Users Transacting") {
        targetValue = formatTargetValue(summary.current_month_gtv_target);
      }
    }

    return (
      <tr
        key={index}
        className={data.isClickable ? "clickable-row" : ""}
        onClick={() => data.isClickable && handleCurrentMonthClick(data.Tier)}
      >
        <td
          className={`${data.isParameterBlue ? "text-primary fw-bold" : ""}`}
          style={data.isParameterBlue ? { color: "#007bff" } : {}}
        >
          {data.Tier}
        </td>
        <td className="text-end">{targetValue}</td>
        <td className={`text-end ${data.isClickable ? "clickable-cell" : ""}`}>
          {data.currentMonth ?? "-"}
        </td>
        <td className="text-end">{data.lmtd ?? "-"}</td>
        <td className="text-end">{data.previousMonth ?? "-"}</td>
        <td className="text-end">{data.previousToPreviousMonth ?? "-"}</td>
      </tr>
    );
  });

  const headerTitleStyle = useMemo(() => {
    const baseStyle = { margin: 0, display: "flex", alignItems: "center" };
    if (showDetailTable && !showStoreDashboard) {
      return { ...baseStyle, fontSize: "1.85rem", lineHeight: 1.2 };
    }
    return baseStyle;
  }, [showDetailTable, showStoreDashboard]);

  // Compute isProcessing from all loading states
  const isProcessing =
    loading || loadingSummary || loadingDetails || loadingStoreDashboard;

  return (
    <div className="dashboard-container">
      <div className="card dashboard-header-card">
        <div
          className="dashboard-header"
          style={{ flexDirection: "column", gap: "8px" }}
        >
          {/* Row 1: Back Button */}
          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
            {!showDetailTable && !showStoreDashboard ? (
              <button
                className="btn btn-back"
                onClick={handleBackToSalesPerformance}
                disabled={isProcessing}
              >
                <ArrowLeft size={16} />
                Back
              </button>
            ) : showDetailTable || showStoreDashboard ? (
              <button
                className="btn btn-back"
                onClick={handleBack}
                disabled={isProcessing}
              >
                <ArrowLeft size={16} />
                Back
              </button>
            ) : null}
          </div>

          {/* Row 2: Title and Filter Button */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <h4
              className={`title ${showStoreDashboard ? "" : "dashboard-title"}`}
              style={headerTitleStyle}
            >
              {renderHeaderTitle()}
            </h4>
            {/* Filter Button (Homepage only) */}
            {!showDetailTable && !showStoreDashboard && (
              <button
                onClick={() => setShowFilters(!showFilters)}
                className="btn btn-outline-secondary btn-filter"
                aria-expanded={showFilters}
                aria-controls="filter-collapse-panel"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  padding: "6px 12px",
                  fontSize: "0.85rem",
                  flexShrink: 0,
                  borderColor: "#6c757d",
                }}
              >
                <Funnel
                  size={14}
                  className="btn-icon"
                  style={{ verticalAlign: "middle" }}
                />
                Filters
              </button>
            )}
          </div>
        </div>
      </div>

      <div
        className="container-fluid card dashboard-content-card"
        style={{ position: "relative" }}
      >
        {/* Loading Indicator - shows over content area */}
        {isProcessing && (
          <div
            className="text-center my-4"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 100,
            }}
          >
            <BeatLoader
              css={override}
              sizeUnit={"px"}
              size={15}
              color={"#4b3092"}
              loading={true}
            />
            <span
              style={{ marginTop: "10px", color: "#4b3092", fontWeight: 500 }}
            >
              Processing...
            </span>
          </div>
        )}

        {/* -------- Level 1: Main Summary Table -------- */}
        {!showDetailTable && !showStoreDashboard && (
          <>
            <Row>
              <Col md={12}>
                <div className="content-tdetails-table table-full-width">
                  {/* --- Collapsible Filter Panel --- */}
                  {showFilters && (
                    <div id="filter-collapse-panel" className="filter-panel-wrapper">
                      <Row className="dashboard-filter-panel">
                        {/* Managers */}
                        {!isICUser && (
                          <Col md={3} xs={12} className="mb-2">
                            <label
                              htmlFor="managersFilter"
                              className="form-label"
                            >
                              Managers:
                            </label>
                            <ReactMultiSelectCheckboxes
                              id="managersFilter"
                              name="managers"
                              styles={customStyles}
                              className="report-listbox"
                              value={selectedManagers}
                              onChange={handleManagersChange}
                              options={managerList}
                              isClearable={true}
                              placeholder="Select managers..."
                              isLoading={loading}
                              components={{ MenuList: VirtualizedMenuList }}
                            />
                          </Col>
                        )}

                        {/* Team Members */}
                        <Col md={3} xs={12} className="mb-2">
                          <label
                            htmlFor="teamMembersFilter"
                            className="form-label"
                          >
                            Team Members:
                          </label>
                          <ReactMultiSelectCheckboxes
                            id="teamMembersFilter"
                            name="teamMembers"
                            styles={customStyles}
                            className="report-listbox"
                            value={selectedUsers}
                            onChange={handleTeamMembersChange}
                            options={userList}
                            isClearable={false}
                            placeholder="Select team members..."
                            isLoading={loading}
                            components={{ MenuList: VirtualizedMenuList }}
                          />
                        </Col>

                        {/* Store Name */}
                        <Col md={3} xs={12} className="mb-2">
                          <label
                            htmlFor="storeNameFilter"
                            className="form-label"
                          >
                            Store Name:
                          </label>
                          <ReactMultiSelectCheckboxes
                            id="storeNameFilter"
                            name="storeName"
                            styles={customStyles}
                            className="report-listbox"
                            value={selectedStore}
                            onChange={handleStoreChange}
                            options={availableStores}
                            isClearable={true}
                            placeholder="Select store..."
                            isDisabled={availableStores.length === 0 || loading}
                            isLoading={loading}
                            components={{ MenuList: VirtualizedMenuList }}
                          />
                        </Col>

                        {/* City */}
                        <Col md={3} xs={12} className="mb-2">
                          <label htmlFor="cityFilter" className="form-label">
                            City:
                          </label>
                          <ReactMultiSelectCheckboxes
                            id="cityFilter"
                            name="city"
                            styles={customStyles}
                            className="report-listbox"
                            value={selectedCity}
                            onChange={handleCityChange}
                            options={availableCities}
                            isClearable={true}
                            placeholder="Select city..."
                            isDisabled={availableCities.length === 0 || loading}
                            isLoading={loading}
                            components={{ MenuList: VirtualizedMenuList }}
                          />
                        </Col>
                      </Row>
                    </div>
                  )}

                  <div className="table-responsive">
                    <table
                      id="categoryWise"
                      className="table table-striped table-hover"
                    >
                      <colgroup>
                        <col style={{ width: "25%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "20%" }} />
                      </colgroup>
                      <thead>
                        <tr>
                          <th>Parameter</th>
                          <th>Target</th>
                          <th>{monthLabels.current}</th>
                          <th>LMTD</th>
                          <th>{monthLabels.prev}</th>
                          <th>{monthLabels.prevPrev}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tireWiseTotal}

                        {/* --- Separator Row --- */}
                        <tr>
                          <td colSpan="6" className="dashboard-separator"></td>
                        </tr>

                        {secondTableData.map((data, index) => {
                          // Map target values based on parameter type
                          let targetValue = "-";
                          if (summary) {
                            if (data.Parameter === "Link GTV (Rs. Lakhs)") {
                              targetValue = formatTargetValue(
                                summary.current_month_gtv_target,
                              );
                            }
                          }

                          return (
                            <tr key={`second-${index}`}>
                              <td>{data.Parameter}</td>
                              <td className="text-end">{targetValue}</td>
                              <td className="text-end">
                                {data.currentMonth ?? "-"}
                              </td>
                              <td className="text-end">{data.lmtd ?? "-"}</td>
                              <td className="text-end">
                                {data.previousMonth ?? "-"}
                              </td>
                              <td className="text-end">
                                {data.previousToPreviousMonth ?? "-"}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
          </>
        )}

        {/* -------- Level 2: Detailed UTID Table -------- */}
        {showDetailTable && !showStoreDashboard && (
          <>
            {/* Search Input */}
            <div className="mb-3" style={{ maxWidth: "300px" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Search by Mobile"
                value={searchQuery}
                onChange={(e) => {
                  // Only update the search query state, don't trigger API call
                  setSearchQuery(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    // Set flag to prevent useEffect from making duplicate call
                    isSearchTriggeredByEnter.current = true;
                    // Reset to first page
                    setCurrentPage(1);
                    // Trigger search on Enter key with current search value
                    const flag =
                      terminalType === "Transacting Terminal(s)"
                        ? "transacting"
                        : "non-transacting";
                    fetchTerminals(flag, searchQuery, 1);
                  }
                }}
                style={{
                  fontSize: "12px",
                  padding: "2px 8px",
                  height: "30px",
                  lineHeight: "30px",
                }}
              />
            </div>
            <DetailedTransactionTable
              onUtidClick={handleUtidClick}
              detailedData={detailedData}
              terminalType={terminalType}
              currentPage={currentPage}
              totalRecords={totalRecords}
              rowsPerPage={rowsPerPage}
              onPageChange={(page) => setCurrentPage(page)}
              onRowsPerPageChange={(count) => {
                setRowsPerPage(count);
                setCurrentPage(1); // reset to first page
              }}
              months={months}
            />
          </>
        )}

        {/* -------- Level 3: Store Dashboard -------- */}
        {showStoreDashboard && selectedUtid && (
          <StoreDashboard
            selectedUtid={selectedUtid}
            storeDashboardData={storeDashboardData}
          />
        )}
      </div>
    </div>
  );
};

export default withRouter(LinkTeamDashboard);
